import { PLATFORM_ENVIRONMENT_BACKEND_API_ROOT_PROD, PLATFORM_ENVIRONMENT_ROOT_PROD } from './public-environment-production-roots';

export interface CheckoutDropInEnvironment {
  staticPagesUrl: string;
  apiUrl: string;
  webshopUrl: string;
  webshopDemoUrl: string;
}

export const CHECKOUT_DROP_IN_ENVIRONMENT_FOR_URL_ROOTS: (rootUrl?: string, apiRootUrl?: string) => CheckoutDropInEnvironment = (
  rootUrl: string = PLATFORM_ENVIRONMENT_ROOT_PROD,
  apiRootUrl: string = PLATFORM_ENVIRONMENT_BACKEND_API_ROOT_PROD
) => ({
  apiUrl: apiRootUrl + '/chckout',
  apiRoot: apiRootUrl,
  staticPagesUrl: rootUrl + '/app/static',
  webshopUrl: rootUrl + '/app/checkout',
  webshopDemoUrl: rootUrl + '/app/checkout-demo'
});
